import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import * as React from "react";
import { SetupWizardStep, useSetupWizardStore } from "../useSetupWizardStore";

const STEPS: SetupWizardStep[] = ["calibrate", "confirm"];

export const WizardStepper: React.FC = () => {
  const theme = useTheme();
  const { currentStep } = useSetupWizardStore();
  const currentIndex = STEPS.indexOf(currentStep);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      {STEPS.map((_, index) => {
        const isCompleted = index < currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <Box
            key={index}
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: isCompleted
                ? theme.palette.primary.main
                : isCurrent
                ? theme.palette.text.primary
                : theme.palette.action.disabled,
              transition: "all 0.3s ease",
              transform: isCurrent ? "scale(1.25)" : "scale(1)",
            }}
          />
        );
      })}
    </Box>
  );
};
